import { EventEmitter } from 'eventemitter3';
import Worker from 'web-worker';
import { Env } from '../../Env';
import { createWorker } from '../../utils/workerUtils';
export class VideoPlayerWrapper extends EventEmitter {
    worker;
    currentCanvas;
    async init() {
        return new Promise((resolve, _reject) => {
            // Not DRY, but otherwise webpack won't transform the worker url
            if (Env.BUILD_TRANSFORMS_FILENAMES) {
                this.worker = new Worker(new URL('./workers/videoplayer.worker.ts', import.meta.url));
            }
            else {
                this.worker = createWorker('./workers/videoplayer.worker.js', import.meta.url);
            }
            this.worker.onmessage = (e) => {
                const { type } = e.data;
                switch (type) {
                    case 'initCompleted':
                        resolve();
                        break;
                    case 'decodedFrame':
                        this.emit('decodedFrame');
                        break;
                    case 'resetCompleted':
                        this.emit('workerResetCompleted');
                        break;
                }
            };
            this.worker.postMessage({
                type: 'init',
            });
        });
    }
    start(presentationTimeMicros, canvas) {
        let offscreenCanvas;
        if (this.currentCanvas !== canvas) {
            this.currentCanvas = canvas;
            canvas.style.visibility = 'visible';
            offscreenCanvas = canvas.transferControlToOffscreen();
        }
        const transferList = offscreenCanvas ? [offscreenCanvas] : [];
        this.worker?.postMessage({
            type: 'start',
            data: {
                presentationTimeMicros,
                canvas: offscreenCanvas,
            },
        }, transferList);
    }
    async feedVideoFrames(frames) {
        this.worker?.postMessage({
            type: 'feedVideoFrames',
            data: { frames },
        });
    }
    reset() {
        return new Promise((resolve) => {
            this.once('workerResetCompleted', () => {
                resolve();
            });
            this.worker?.postMessage({
                type: 'reset',
            });
        });
    }
    setReferenceTimes(presentationTimeMicros, realTimeMillis) {
        this.worker?.postMessage({
            type: 'setReferenceTimes',
            data: { presentationTimeMicros, realTimeMillis },
        });
    }
}
